import Row from "components/atoms/Row";
import { Article } from "interfaces/articles/ArticlesInterfaces";
import React, { FunctionComponent } from "react";
import { Col } from "reactstrap";
import CardArticle from "./CardArticle";
import CardArticleWide from "./CardArticleWide";
import NoResult from "./NoResult";

interface ArticleListProps {
  classname?: string;
  articles: Article[];
  highlightArticles?: Article[];
}

const ListArticles: FunctionComponent<ArticleListProps> = ({
  articles,
  highlightArticles= []
}) => {
  
  const sortByCreatedAtDesc = (articles: Article[]) =>
    articles
      .filter((article: Article): boolean => !!article)
      .sort((a: Article, b: Article) =>
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      );

  const sortByHighlightedAtDesc = (articles: Article[]) =>
    articles
      .filter((article: Article): boolean => !!article)
      .sort((a: Article, b: Article) =>
        new Date(b.highlighted_at ?? b.created_at).getTime() -
        new Date(a.highlighted_at ?? a.created_at).getTime()
      );

  const filteredArticles = sortByCreatedAtDesc(articles);
  const filteredHighlightArticles = sortByHighlightedAtDesc(highlightArticles);
  
  return (
    <>
      {filteredArticles.length === 0 && filteredHighlightArticles.length === 0 && <NoResult />}

      <Row grid>
        {filteredHighlightArticles.map((article) =>
          <Col xs="12" md="12" key={article.id} >
            <CardArticleWide article={article} noBorder/>
          </Col>
        )}
        {filteredArticles.map((article) =>
          <Col xs="12" md="4" key={article.id} >
            <CardArticle article={article} noBorder/>
          </Col>
        )}
      </Row>
    </>
  )
}

export default ListArticles
